<template lang="pug">
  .reports-wrapper
    h2 relatórios e registros
    .filters
      div(style="margin-bottom: 10px")
        h3.color-primary(style="margin: 5px 0 5px 0") {{ selectedReport.id }} - {{ selectedReport.name }}
        span {{ selectedReport.description }}

      template(v-if="selectedReport.filters")
        .items-slider
          RadioSlider(
            :items="filters.categories.items",
            :current="filters.categories.items.findIndex(i => i.id === categorieSelected.id)",
            :disabledModes="disabledCategories"
            @selected="openItemsSelector"
          )

        PMultiSelect.items-selector(
          ref="itemSelector"
          labelItem="name"
          v-model="$data.filters[categorieSelected.state]"
          :title="categorieSelected.name"
          :useCommon="categorieSelected.common"
          :class="{'fill-next-column': categorieSelected.id !== 'employee'}"
        )

      MonthAndPeriodSelection(:reportKinds="selectedReport.dateSelecion" ref="monthPeriodSelection" v-model="periodData")

      .custom-options
        component(:is="selectedReport.id" :reportInfo="reportInfo" @handleReport="handleReport" @changeCommon="changeCommon" :valid="validToGen")

    .right-side
      h3.fs-15 relatórios:
      .grid
        span.to-click.fs-15.report-item.noselect(v-for="(item, index) in reportsInfos" :key="index" v-if="item.show"
          style="text-align: center;" :class="{selected: item.id === selectedReport.id}" @click="onSelectReport(item)")
          | {{ item.id }} - {{ item.name }}

      hr
      h3.fs-15 exportações:
      .grid
        span.to-click.fs-15.report-item.noselect(v-for="(item, index) in exportInfos" :key="index" v-if="item.show"
          style="text-align: center;" :class="{selected: item.id === selectedReport.id}" @click="onSelectReport(item)")
          | {{ item.id }} - {{ item.name }}

      hr
      h3.fs-15 importações:
      .grid
        span.to-click.fs-15.report-item.noselect(v-for="(item, index) in importerInfos" :key="index" v-if="item.show"
          style="text-align: center;" :class="{selected: item.id === selectedReport.id}" @click="onSelectReport(item)")
          | {{ item.id }} - {{ item.name }}

</template>

<script>
import importerInfos from './importerInfos'
import reportsInfos, { components } from './reportsInfos'
import exportInfos from './exportsInfos'
import MonthAndPeriodSelection from './MonthAndPeriodSelection'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'Reports',
  components: {MonthAndPeriodSelection, ...components},
  mounted () {
    setAmplitudeEvent('lista relatorios', {})
  },
  created () {
    this.filters.categories = this.defaultCategories()
    this.selectedReport = reportsInfos[0]
    this.filters.categories.selected = this.filters.categories.items[0]
  },
  data () {
    return {
      reportsInfos,
      exportInfos,
      importerInfos,
      periodData: {},
      selectedReport: null,
      filters: {
        companies: {selected: []},
        employers: {selected: []},
        employees: {selected: []},
        users: {selected: []},
        userGroups: {selected: []},
        supervisors: {selected: []},
        categories: null
      }
    }
  },
  computed: {
    validToGen () {
      return Boolean(
        this.reportInfo.entityContent.length >= 1 ||
        !this.selectedReport.filters
      )
    },
    reportInfo () {
      const categorieSelected = this.categorieSelected
        ? this.categorieSelected
        : this.defaultCategories().items[0]

      return {
        periodData: this.periodData,
        entityContent: this.filters[categorieSelected.state].selected,
        entity: categorieSelected.entity
      }
    },
    categorieSelected () {
      return this.filters.categories.selected
    },
    disabledCategories () {
      return this.selectedReport.filters
        ? this.filters.categories.items.filter(i => !this.selectedReport.filters.includes(i.id)).map(i => i.id)
        : this.filters.categories.items
    }
  },
  methods: {
    defaultCategories () {
      return {
        selected: null,
        items: [
          { name: this.$wp('company'), id: 'company', common: 'companies/onlyActive', state: 'companies', entity: 'companies' },
          { name: 'empregadores', id: 'employer', common: 'employers', state: 'employers', entity: 'employer' },
          { name: this.$wp('employee'), id: 'employee', common: 'employees/onlyNotFired', state: 'employees', entity: 'employees' },
          { name: 'grupos', id: 'userGroup', common: 'userGroups', state: 'userGroups', entity: 'user_group' },
          { name: this.$wp('user'), id: 'users', common: 'users', state: 'users', entity: 'users' },
          { name: 'responsável', id: 'supervisor', common: 'supervisors', state: 'supervisors', entity: 'supervisor' }
        ]
      }
    },
    openItemsSelector (item) {
      this.filters.categories.selected = item
    },
    onSelectReport (item) {
      this.selectedReport = item
      this.filters.categories = this.defaultCategories()
      this.$nextTick(this.$refs.monthPeriodSelection.resetKind)
      this.$nextTick(this.$refs.monthPeriodSelection.updateState)

      if (this.selectedReport.filters) {
        this.filters.categories.selected = this.filters.categories.items
          .find(i => this.selectedReport.filters.includes(i.id))
      }
    },
    getCustomOptionsToSendBack () {
      const el = this.$el.querySelector('.custom-options')

      if (el && !el.__vue__.getOptions) {
        throw new Error(
          'All compoenents of report custom options must have a method called getOptions. ' +
          'The root Report component will call it to get data that must be send to backend'
        )
      }

      return el ? el.__vue__.getOptions() : null
    },
    async handleReport (apiResponse) {
      if (apiResponse?.data?.success) {
        this.$swal({
          type: 'success',
          text: apiResponse.data.success
        })
      } else if (apiResponse?.data?.info) {
        this.$swal({
          type: 'info',
          text: apiResponse.data.info
        })
      } else {
        console.error(apiResponse)
        if (apiResponse?.status === 403) {
          this.$swal({
            type: 'error',
            text: apiResponse?.data?.error ? apiResponse.data.error : 'Você não tem permissão para gerar esse relatório'
          })
        } else {
          this.$swal({
            type: 'error',
            text: apiResponse?.data?.error ? apiResponse.data.error : 'Não foi possível gerar o relatório'
          })
        }
      }
      this.$checkUserFiles()
    },
    async changeCommon (id, common) {
      const categorie = this.filters.categories.items.find(categorie => categorie.id === id)
      categorie.common = common
    }
  }
}
</script>

<style scoped lang="scss">
.reports-wrapper {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  grid-column-gap: 50px;

  h2 { grid-column: 1/3; text-align: center }

  .filters {
    display: grid;
    grid-column: 1/2;
    grid-row-gap: 20px;
    grid-auto-rows: max-content;

    .period {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }

  .right-side {
    .grid {
      grid-column: 2/4;
      display: grid;
      max-height: 250px;
      overflow-y: auto;
      padding-right: 5px;
      grid-column-gap: 30px;
      grid-row-gap: 10px;

      span.report-item {
        padding: 6px;
        border-radius: 3px;
        text-align: left !important;
        background-color: lightgrey;

        &.selected {
          background-color: var(--color-warning);
        }
      }
    }
  }
}
</style>
